module.exports = __webpack_public_path__ + "media/images/block-action-icon-e823e402918b0b14b92d9440b1be38e9.svg";